import JsonLD, {
  JsonLDArticle as _JsonLDArticle,
  JsonLDBreadcrumbList as _JsonLDBreadcrumbList,
  JsonLDContactPoint as _JsonLDContactPoint,
  JsonLDImageObject as _JsonLDImageObject,
  JsonLDListItem as _JsonLDListItem,
  JsonLDOrganization as _JsonLDOrganization,
  JsonLDPerson as _JsonLDPerson,
  JsonLDPostalAddress as _JsonLDPostalAddress,
} from './json-ld.component'

export { JsonLDType } from './json-ld.component'

export type JsonLDArticle = _JsonLDArticle
export type JsonLDBreadcrumbList = _JsonLDBreadcrumbList
export type JsonLDContactPoint = _JsonLDContactPoint
export type JsonLDImageObject = _JsonLDImageObject
export type JsonLDListItem = _JsonLDListItem
export type JsonLDOrganization = _JsonLDOrganization
export type JsonLDPerson = _JsonLDPerson
export type JsonLDPostalAddress = _JsonLDPostalAddress

export default JsonLD
